<template>
    <div class="start-vigilance-page page" v-if="needSelection">
        <div class="page-header">
            <h4>Seleccione el punto de acceso en el cual va a vigilar</h4>
        </div>
        <div class="page-body d-flex flex-wrap justify-content-around">
            <div class="structure-link" v-for="structure in accessPointStructures" @click="selectStructure(structure)">
                <app-structure-card :structure="structure" :key="structure.id"></app-structure-card>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import StructureCard from './StructureCard.vue';

    export default {
        components: {
            appStructureCard: StructureCard
        },
        data(){
            return {
                needSelection: false
            }
        },
        computed: {
            ...mapGetters(['structures', 'accessPoint']),
            accessPointStructures(){
                return !!this.structures? this.structures.filter(structure => !!structure.structure_type.access_point): [];
            }
        },
        methods: {
            selectStructure(structure){
                this.$store.commit('accessPoint', structure);
                this.$store.dispatch('persistState');
                // this.$router.push({ name: 'generalStatus' });
                this.$router.push({ name: 'shiftStartPage' });
            }
        },
        created(){
            if(!!this.accessPoint){
                this.$router.push({ name: 'generalStatus' });
            }else{
                this.needSelection = true;
            }
        }
    }
</script>